<template>
  <div>
    <!-- 支付方式选择弹窗 -->
    <el-dialog
      :visible.sync="paymentTypeDialogVisible"
      width="730px"
      class="payment-type-dialog"
      title="订单支付"
      @close="handlePayFinish"
      :close-on-click-modal="false"
    >
      <div class="order-info">
        <p class="title">订单信息：{{ orderData.order_no }}</p>
        <p class="student">
          {{ orderData.student.name }}
          <span class="seprate">|</span>
          {{ orderData.student.mobile }}
        </p>
        <p class="total">
          <span>
            待付金额：￥
            <span class="mwow-red">
              {{ unpayAmount }}
            </span>
          </span>
        </p>
      </div>

      <div class="mwow-form block">
        <div class="item">
          <span class="label">付款方式：</span>
          <el-radio-group
            v-model="paymentTypeRadio"
            class="cashier-wrap"
            @change="handlePaymentTypeCheck"
          >
            <el-radio
              border
              :label="item.key"
              v-for="item in payType.filter((it) => {
                if (it.key === 10 || it.key === 7) {
                } else {
                  return it;
                }
              })"
              :key="item.key"
              size="mini"
              :disabled="!orderData.online_pay && item.key === 999"
              class="mwow-radio"
              :class="{
                'disable-radio': !orderData.online_pay && item.key === 999,
              }"
            >
              {{ item.value }}
              <span
                class="open"
                v-if="!orderData.online_pay && item.key === 999"
                @click="handleOpenOnlinePayClick"
              >
                立即开通
              </span>
            </el-radio>
          </el-radio-group>
        </div>
        <div
          class="item pay-time"
          v-if="paymentTypeRadio !== 999 || !orderData.online_pay"
        >
          <span class="label">支付时间：</span>
          <span>
            <el-date-picker
              v-model="payForm.handle_time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="payHandleTimedisableOptions"
              :clearable="false"
            >
            </el-date-picker>
          </span>
        </div>
        <div class="select-type border">
          <el-radio-group v-model="selectTypeRadio">
            <el-radio border size="mini" :label="1" :key="1">
              <span>全额付款</span>
              <span class="text price-icon"> ￥{{ unpayAmount }} </span>
            </el-radio>
            <el-radio
              v-if="orderData.order_type !== 3"
              border
              size="mini"
              :label="2"
              :key="2"
              :class="{ stage: Number(selectTypeRadio) === 2 }"
            >
              <span> 分期付款 </span>
              <span
                v-if="Number(selectTypeRadio) === 2"
                class="text price-icon"
              >
                ￥
                <el-input
                  v-model="payForm.amount"
                  placeholder="请输入"
                  type="number"
                  @input="
                    (v) => {
                      if (/\.\d{3}/.test(String(v))) {
                        $message({
                          type: 'warning',
                          message: '请保留两位小数',
                        });
                        payForm.amount = Math.floor(Number(v) * 100) / 100;
                        return false;
                      }
                    }
                  "
                  @blur="handleAmountBlur"
                  ref="stageRef"
                ></el-input>
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="btn-wrap">
        <div class="mwow-button-filled success" @click="submitPaymentType">
          确定
        </div>
        <div
          class="mwow-button-filled"
          style="margin-left: 20px"
          @click="closePaymentTypeDialog"
        >
          取消
        </div>
      </div>
    </el-dialog>
    <!-- 付款完成，审核提示 -->
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="orderData.order_id"
      @close="handlePayFinish"
    ></approve-tips-dialog>
    <!-- 开通弹窗 -->
    <open-online-pay-dialog
      :visible="openOnlinePayVisible"
      @change="handleOpenOnlinePayChange"
    >
    </open-online-pay-dialog>
    <!-- 线上扫码合并弹窗 -->
    <merge-scan-type-dialog
      v-if="mergeScanTypeDialogVisible"
      @change="handleMergeScanTypeChange"
      :originData="payCodeDialogData"
    >
    </merge-scan-type-dialog>
  </div>
</template>
<script>
// 订单创建完有两种情况：线下支付、线上支付但商品价格为0时，订单会直接变为支付完成
// 所以能打开支付弹窗的订单都是分期支付的
import { dateFormat } from "@/utils/timeFormat";
import { solveLargeNumber } from "@/utils/common";
import {
  changePaymentTypeApi,
  checkFinishApi,
  getHuifuPaymentUrlApi,
} from "@/api/order";
import approveTipsDialog from "@/components/approveTipsDialog.vue";
import mergeScanTypeDialog from "@/components/mergeScanTypeDialog.vue";
import openOnlinePayDialog from "@/components/openOnlinePayDialog.vue";

export default {
  props: {
    orderData: {
      type: Object,
      default: function () {
        return {
          item: [],
          student: {},
          online_pay: false,
        };
      },
    },
    payType: {
      type: Array,
      default: function () {
        return [];
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    approveTipsDialog,
    mergeScanTypeDialog,
    openOnlinePayDialog,
  },
  computed: {
    unpayAmount() {
      return (
        (solveLargeNumber(this.orderData.receivable_amount) -
          solveLargeNumber(this.orderData.completed_amount)) /
        100
      ).toFixed(2);
    },
  },
  watch: {
    visible(n) {
      this.paymentTypeDialogVisible = n;
      if (n) {
        this.payForm.amount = "";
        if (this.payType && this.payType.length > 0) {
          this.paymentTypeChecked = this.payType[0];
          if (this.orderData.online_pay) {
            this.paymentTypeRadio = this.payType[0].key;
          } else {
            this.paymentTypeRadio = "";
          }
          this.payForm.handle_time = dateFormat("YYYY-mm-dd HH:MM", new Date());
        }
      }
    },
    // 支付方式为分期付款时，自动获取焦点并选中内容
    selectTypeRadio: {
      handler(n, o) {
        if (Number(n) === 2) {
          this.$nextTick(() => {
            this.$refs["stageRef"].focus();
            this.$refs["stageRef"].select();
          });
        }
      },
    },
  },
  data() {
    return {
      paymentTypeDialogVisible: false, // 显示支付方式弹窗
      paymentType: [], // 支付方式列表
      paymentTypeChecked: {}, // 选择的支付方式
      paymentTypeRadio: "", // 选中的支付方式label
      payForm: {
        // 支付方式表单
        amount: "",
        handle_time: "",
      },
      payHandleTimedisableOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      scanPayCodeDialogVisible: false, // 扫码机弹窗展示
      scanPayCodeDialogData: {}, // 扫码机弹窗数据
      paymentCodeDialogVisible: false, // 付款码弹窗展示
      payCodeDialogData: {}, // 付款码弹窗数据
      approveDialogVisible: false, // 审批提示弹窗展示
      openOnlinePayVisible: false, // 开通乐沃收银 dialog
      selectTypeRadio: 1, // 选中的全额还是分期，默认选中全额付款
      mergeScanTypeDialogVisible: false,
    };
  },
  methods: {
    solveDateFormat(time) {
      return dateFormat("YYYY-mm-dd", time * 1000);
    },
    // 选择的支付方式
    handlePaymentTypeCheck() {
      this.paymentTypeChecked = this.payType.find((item) => {
        if (item.key === this.paymentTypeRadio) {
          return item;
        }
      });
    },
    handleAmountBlur() {
      if (this.payForm.amount !== "" && Number(this.payForm.amount) <= 0) {
        this.$message({
          type: "warning",
          message: "分期支付时金额需大于0",
        });
        // 异步执行，失焦与点击确定同时触发时，先判断，再异步赋值
        setTimeout(() => {
          this.payForm.amount = "";
        }, 200);
        return false;
      }
      if (Number(this.unpayAmount) <= Number(this.payForm.amount)) {
        this.$message({
          type: "warning",
          message:
            "分期付款时，现付金额应小于待付金额" + this.unpayAmount + "元",
        });
        // 异步执行，失焦与点击确定同时触发时，先判断，再异步赋值
        setTimeout(() => {
          this.payForm.amount = "";
        }, 200);
        return false;
      }
      // this.payForm.amount = Math.abs(Number(this.payForm.amount)).toFixed(2);
    },
    // 确认支付方式和金额
    submitPaymentType() {
      if (this.payForm.amount !== "" && Number(this.payForm.amount) <= 0) {
        return false;
      }
      if (Number(this.unpayAmount) <= Number(this.payForm.amount)) {
        return false;
      }
      if (this.selectTypeRadio === 2) {
        if (!this.payForm.amount) {
          this.$message({
            type: "warning",
            message: "分期付款时，金额不能为空",
          });
          return;
        }
      }
      if (!this.paymentTypeRadio) {
        this.$message({
          type: "warning",
          message: "请先选择付款方式",
        });
        return false;
      }
      if (this.paymentTypeChecked.key !== 999 || !this.orderData.online_pay) {
        // 在线支付-现金 或线下支付
        changePaymentTypeApi({
          order_id: this.orderData.order_id,
          payment_methods: [
            {
              payment_method_id: Number(this.paymentTypeChecked.key),
              amount:
                Number(this.selectTypeRadio) === 1
                  ? String(this.unpayAmount)
                  : String(this.payForm.amount),
            },
          ],
          handle_time: this.payForm.handle_time + ":00",
        }).then((res) => {
          checkFinishApi({
            order_payment_id: res.data.order_payment_id,
          }).then((cres) => {
            if (cres.data.payment_status === 3) {
              if (cres.data.approval_id) {
                // 需要审核
                this.approveDialogVisible = true;
              } else {
                // 不需要审核
                this.$message({
                  type: "success",
                  message: "支付成功",
                });
                this.handlePayFinish();
              }
            }
          });
        });
      }
      // 线上支付
      if (
        this.paymentTypeChecked.key === 7 ||
        this.paymentTypeChecked.key === 999
      ) {
        getHuifuPaymentUrlApi({
          order_id: this.orderData.order_id,
          payer_amount:
            Number(this.selectTypeRadio) === 1
              ? String(this.unpayAmount)
              : String(this.payForm.amount),
        }).then((res) => {
          let courseFlat = [];
          this.orderData.item.map((item) => {
            item.list.map((it) => {
              it.discount = it.discount_amount;
              it.sum = it.receivable_amount;
              courseFlat.push(it);
            });
          });
          let amount =
            Number(this.selectTypeRadio) === 1
              ? String(this.unpayAmount)
              : String(this.payForm.amount);
          this.payCodeDialogData = {
            order_no: res.data.order_no,
            order_payment_id: res.data.order_payment_id,
            item: courseFlat,
            order_id: this.orderData.order_id,
            amount: amount,
            efficient_time: res.data.efficient_time,
            counter_url:
              process.env.VUE_APP_H5_HOST +
              "/order-pay.html?a=" +
              res.data.order_no +
              "&b=" +
              res.data.order_payment_id,
            create_time: this.orderData.create_time,
            student_name: this.orderData.student.name,
            student_mobile: this.orderData.student.mobile,
            payType: this.payType,
          };
          this.paymentCodeDialogVisible = true;
          // v2.56.x
          this.paymentTypeDialogVisible = false;
          this.mergeScanTypeDialogVisible = true;
        });
      }
    },
    // 关闭支付方式弹窗
    closePaymentTypeDialog() {
      this.paymentTypeDialogVisible = false;
      this.selectTypeRadio = 1;
    },
    // 支付完成，通知父组件
    handlePayFinish() {
      this.closePaymentTypeDialog();
      this.$emit("update:visible", false);
      this.paymentCodeDialogVisible = false;
      this.scanPayCodeDialogVisible = false;
      this.$emit("finish");
    },
    handleOpenOnlinePayClick() {
      this.openOnlinePayVisible = true;
    },
    handleMergeScanTypeChange() {
      this.mergeScanTypeDialogVisible = false;
      this.$emit("finish");
    },
    handleOpenOnlinePayChange() {
      this.openOnlinePayVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.payment-type-dialog {
  .order-info {
    margin-bottom: 24px;
    background: rgba(242, 246, 250, 1);
    border-radius: 8px;
    padding: 20px 36px;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(92, 93, 94, 1);
      margin-bottom: 21px;
    }
    .student {
      font-size: 12px;
      color: #333;
      margin-bottom: 21px;
      .seprate {
        margin: 0 8px;
      }
    }
    .total {
      font-size: 12px;
      color: #333;
      display: flex;
      span {
        flex: 1;
      }
    }
  }
  .pay-wrap {
    display: flex;
    border-bottom: 1px solid #e7e8ea;
    margin-bottom: 24px;
    .item {
      flex: 1;
      .box {
        margin-bottom: 20px;
        s .text {
          margin-left: 10px;
        }
      }
      /deep/ .box {
        .is-checked {
          .el-radio__inner {
            border-color: #07d1aa;
            background: #07d1aa;
          }
          .el-radio__label {
            color: #07d1aa;
          }
        }
      }
    }
  }
  .block {
    padding-left: 35px;
    .item {
      display: flex;
      line-height: 28px;
      font-size: 12px;
      color: #5c5d5e;
      .label {
        min-width: 65px;
        font-size: 12px;
      }
      /deep/ .cashier-wrap {
        .el-radio {
          width: 182px;
          height: 32px !important;
          margin: 0 16px 22px 0 !important;
          &:nth-child(3n) {
            margin: 0 0 22px 0 !important;
          }
          .open {
            color: white;
            background: #07d1aa;
            padding: 5px 9px;
            border-radius: 3px;
            font-size: 10px;
            cursor: pointer;
          }
        }
        /deep/.disable-radio {
          padding: 6px 7px 0 10px !important;
          .is-disabled {
            .el-radio__inner {
              background: none;
              border: 1px solid rgba(231, 232, 234, 1);
              &::after {
                width: 0;
                height: 0;
              }
            }
          }
          .el-radio__label {
            color: rgba(194, 195, 196, 1) !important;
          }
        }
      }
      .content {
        .red {
          color: #f56c6c;
        }
        &.error {
          .box {
            &.active {
              border: 1px solid #f56c6c !important;
            }
          }
        }
        .box {
          display: inline-block;
          margin-right: 38px;
          border: 1px solid #e7e8ea;
          border-radius: 4px;
          padding: 0 8px;
          &.active {
            border-color: #07d1aa;
          }
          .text {
            margin: 0 8px;
          }
          .input {
            font-size: 12px;
            color: #5c5d5e;
            width: 60px;
            border: 0;
          }
        }
      }
    }
    .select-type {
      padding: 0 65px;
      &.border {
        border-top: 1px solid #e7e8ea;
        padding-top: 20px;
      }
      .el-radio {
        width: 182px;
        height: 32px !important;
        margin: 0 20px 16px 0 !important;
        .price-icon {
          margin-left: 5px;
        }
      }
      /deep/.stage {
        padding: 0px 10px;
        .el-input {
          width: 72px;
          .el-input__inner {
            height: 28px !important;
            line-height: 27px !important;
            padding: 0;
            border: none;
          }
        }
        .unpay {
          margin-left: 20px;
        }
      }
    }
    .pay-time {
      padding-bottom: 20px;
      .el-input {
        width: 182px;
      }
    }
  }

  .btn-wrap {
    text-align: right;
    .mwow-button-filled {
    }
  }
}

/deep/ .form-wrap {
  .el-form-item__label {
    padding: 0;
    &::before {
      content: "" !important;
    }
  }
}
</style>
